import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Neue Artikel',
  tabs: {
    [Tab.General]: 'Allgemeines',
    [Tab.NutritionInfo]: 'Nährwertangaben',
  },
  form: {
    categories: {
      label: 'Kategorien',
    },
    printer: {
      label: 'Drucker',
    },
    name: {
      label: 'Name',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Beschreibung',
      placeholder: '180g beef Patty, Salat, Tomaten, Gurken, Jalapeños and Yuppi sauce',
    },
    external_id: {
      label: '{{integration}}-Referenz',
      placeholder: 'z. B. HubRise-SKU-Referenz',
      read_only_hint:
        'Nur bearbeitbar, solange eine HubRise-Integration verbunden und die Menüsynchronisierung deaktiviert ist.',
    },
    price: {
      label: 'Basis Preis',
    },
    has_smart_pricing: {
      label: 'Spezielle Preise für Abholung und Lieferung',
    },
    pickup_price: {
      label: 'Abholpreis',
      placeholder: 'Nicht spezifiziert',
    },
    delivery_price: {
      label: 'Lieferpreis',
      placeholder: 'Nicht spezifiziert',
    },
    image: {
      label: 'Bild (optional)',
    },
    has_combo_tax: {
      label: 'Hat Combo-Steuer',
    },
    is_available: {
      label: 'Auf Lager',
      subtitle: 'Wird im Menü angezeigt',
    },
    is_visible: {
      label: 'Sichtbar',
      title: 'Im Menü sichtbar',
      subtitle_on: 'Kunden sehen diesen Artikel',
      subtitle_off: 'Für alle Kunden ausgeblendet',
    },
    is_available_for_pickup: {
      label: 'Für Abholung verfügbar',
      subtitle_on: 'Kunden können zur Abholung bestellen',
      subtitle_off: 'Im Abholmenü ausgeblendet',
    },
    is_available_for_delivery: {
      label: 'Für Lieferung verfügbar',
      subtitle_on: 'Kunden können zur Lieferung bestellen',
      subtitle_off: 'Im Liefermenü ausgeblendet',
    },
    modifiers: {
      label: 'Optionen',
    },
  },
  labels: {
    smart_pricing_update_warning:
      'Durch das Aktualisieren werden alle vorhandenen Smart Pricing-Regeln für dieses Produkt überschrieben.',
    smart_pricing_remove_warning:
      'Nach dem Speichern werden alle vorhandenen Smart Pricing-Regeln für dieses Produkt entfernt.',
  },
  availability: {
    title: 'Verfügbarkeit',
    helper:
      'Sichtbarkeit ist der Hauptschalter. Schalte einen Kanal aus, um diesen Artikel für Abhol- oder Lieferkunden auszublenden, ohne ihn aus dem Menü zu entfernen.',
    status: {
      both: 'Beide Kanäle',
      pickup_only: 'Nur Abholung',
      delivery_only: 'Nur Lieferung',
      hidden: 'Ausgeblendet',
      no_channels: 'Keine Kanäle',
    },
    warning: {
      no_channels: 'Dieser Artikel ist sichtbar, aber auf keinem Kanal verfügbar — Kunden können ihn nicht bestellen.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Nur Abholung',
      delivery_only: 'Nur Lieferung',
      no_channels: 'Keine Kanäle',
    },
  },
  buttons: {
    save: 'Speichern',
    close: 'Schließen',
  },
  toasts: {
    changes_got_saved: 'Die Änderungen wurden erfolgreich gespeichert!',
  },
};
